import { render, staticRenderFns } from "./RenderModal.vue?vue&type=template&id=195021be&scoped=true"
import script from "./RenderModal.vue?vue&type=script&lang=js"
export * from "./RenderModal.vue?vue&type=script&lang=js"
import style0 from "./RenderModal.vue?vue&type=style&index=0&id=195021be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195021be",
  null
  
)

export default component.exports